import { useLocalStorage } from '@vueuse/core'

export function useImpersonationLocation() {
  const position = useLocalStorage(
    'impersonationIndicator_position',
    { x: 0, y: 0 },
    {
      mergeDefaults: true,
    },
  )

  function reset() {
    position.value = { x: 0, y: 0 }
  }

  return { position, reset }
}
